<template>
  <div>
    <table class="table table-bordered">
      <thead class="bg-dark text-white">
        <tr>
          <th class="text-center">
            <div>{{ $t("common.language") }} <LanguageFilter indent="template" :request="request" @changed="languageFilterChanged" /></div>
          </th>
          <th class="align-middle">{{ $t("common.version") }}</th>
          <th class="align-middle">{{ $t("legal-document-review.name") }}</th>
          <th class="align-middle">{{ $t("legal-document-template.name") }}</th>
          <th class="align-middle">
            <a href="javascript:;" @click="toggleFilter">
              <span v-if="filterEnabled" class="text-warning">
                <i class="bx bxs-filter-alt"></i>
                {{ $t("common.filters-hide") }}
              </span>
              <span v-else class="text-white">
                <i class="bx bxs-filter-alt"></i>
                {{ $t("common.filters-show") }}
              </span>
            </a>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="filterEnabled">
          <th></th>
          <th></th>
          <th><input class="form-control" v-model="nameFilter" /></th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
        <template v-if="pagination">
          <tr v-for="item in pagination.docs" :key="item._id">
            <td>
              <language-badge v-if="item.template" :langCode="item.template.language" />
            </td>
            <td>{{ item.version }}</td>
            <td>{{ item.name | translate }}</td>
            <td>
              <span v-if="item.template">
                {{ item.template.name | translate }}
              </span>
            </td>

            <td>
              <i class="bx bx-error-circle text-danger hand mr-3 font-size-14" v-b-tooltip.hover :title="$t('legal-document-review.reject')" @click="deleteById(item._id)"></i>
              <i
                class="bx bx-check-circle text-success hand mr-3 font-size-14"
                v-b-tooltip.hover
                :title="$t('legal-document-review.approve')"
                @click="prepareForApprove(item._id)"
              ></i>
              <i class="bx bx-pencil text-warning hand mr-3 font-size-14" v-b-tooltip.hover :title="$t('common.edit')" @click="edit(item)"></i>
            </td></tr
        ></template>
      </tbody>
    </table>
    <FileNoAndCategorySelect id="fileNoAndCategorySelect" @selected="approve" />

    <content-loading v-if="isLoading" />
    <empty v-if="!isLoading && (!pagination || pagination.docs.length == 0)" width="200px">
      <h4 class="text-center">{{ $t("common.no-data") }}</h4>
    </empty>
    <!-- Begin: Pagination -->

    <div v-if="pagination" class="row">
      <div class="col">
        <ul class="pagination pagination-rounded mb-0">
          <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
        </ul>
      </div>
    </div>
    <!-- End: Pagination -->
  </div>
</template>

<script>
import LanguageBadge from "@c/language-badge";
import LanguageFilter from "@c/language-filter";
import LibraryItems from "@cc/library-items";
import FileNoAndCategorySelect from "../file-manager/file-no-and-category-select";

const state = "organizationLegalDocument";
export default {
  props: ["product"],
  components: { LibraryItems, LanguageFilter, LanguageBadge, FileNoAndCategorySelect },
  data() {
    return {
      selectedLegalDocumentId: undefined,
      filterEnabled: false,
      nameFilter: undefined,
      request: {
        options: { page: 1, limit: 15, sort: { name: "asc" } },
        query: { approved: { value: false, isObject: true } },
      },
    };
  },
  computed: {
    pagination() {
      return this.$store.getters[`${state}/pagination`];
    },
    isLoading() {
      return this.$store.getters[`${state}/isLoading`];
    },
    hasApproveOrRejectPermission() {
      if (this.currentAccountHasPermissions(["ORGANIZATION_LEGAL_ADMIN"])) {
        return true;
      }

      return false;
    },
  },
  watch: {
    request: {
      deep: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },
    nameFilter(n, o) {
      this.request.query = {
        ...this.request.query,
        name: { value: n },
      };
    },
  },
  mounted() {
    if (this.product) {
      this.request = { ...this.request, query: { ...this.request.query, products: { value: this.product, isObject: true } } };
    }
  },
  methods: {
    toggleFilter() {
      this.filterEnabled = !this.filterEnabled;
    },
    async paginate() {
      await this.$store.dispatch(`${state}/paginate`, this.request);
    },
    languageFilterChanged(e) {
      this.request = e;
    },
    async edit(item) {
      this.$router.push(`/${this.product.toLowerCase()}/legal-document-review/${item._id}`);
    },
    prepareForApprove(id) {
      this.selectedLegalDocumentId = id;
      this.$bvModal.show("fileNoAndCategorySelect");
    },
    async approve(event) {
      try {
        if (!this.selectedLegalDocumentId) {
          return;
        }

        await this.$store.dispatch(`${state}/approve`, {
          id: this.selectedLegalDocumentId,
          fileCategoryId: event?.category?._id,
          fileNo: event?.fileNo,
          admin: { _id: event?.admin?._id, accountId: event?.admin?.accountId },
          isPeriodical: event?.isPeriodical,
          period: event?.period,
        });
        this.paginate();

        if (event?.isPeriodical) {
          this.$toast.success(this.$t("legal-document.periodical-approve-success"), { timeout: 15000 });
          return;
        }
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      } finally {
        this.selectedLegalDocumentId = undefined;
      }
    },

    async deleteById(id) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`${state}/delete`, id);
        this.paginate();
        this.$toast.success(this.$t("common.delete-successful"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>
